<!-- Modal Header -->
@if (showAddAdmin) {
  <div
    class="modal fade show"
    tabindex="-1"
    style="display:block; background:rgba(0,0,0,0.5);"
    >
    <div class="modal-dialog modal-dialog-centered modal-lg" id="add-admin-modal">
      <div class="modal-content">
        <div class="modal-header text-center" >
          <h3 id="hdrImageTitle" class="modal-title" style="color: black">
            {{ dialogTitle }}
          </h3>
          <button
            type="button"
            style="color: black"
            title="Close"
            class="close float-right"
            aria-label="Close"
            (click)="onCloseAddAdmin()"
            >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <!-- Modal body -->
        <div class="container-fluid" style="max-height: 80vh;overflow-y: auto;">
          <div>
            <div class="col-xl-12">
              <div style="border-radius: 1.375rem !important;box-shadow: none !important;">
                <div style="margin-top: 20px;">
                  <form [formGroup]="adminForm" (ngSubmit)="createAdmin()">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-group required">
                          <label class="form-control-label">Name</label>
                          <input type="text" formControlName="name" class="form-control" placeholder="Enter Name">
                          @if (adminForm.get('name').invalid && (adminForm.get('name').dirty || adminForm.get('name').touched)) {
                            <mat-error>Name is required</mat-error>
                          }
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="form-group required">
                          <label class="form-control-label">Designation</label>
                          <input type="text" formControlName="designation" class="form-control" placeholder="Enter Designation">
                          @if (adminForm.get('designation').invalid && (adminForm.get('designation').dirty || adminForm.get('designation').touched)) {
                            <mat-error>Designation is required</mat-error>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-group required">
                          <label class="form-control-label">Email</label>
                          <input type="email" formControlName="email" class="form-control" placeholder="Enter Email">
                          @if (adminForm.get('email').invalid && (adminForm.get('email').dirty || adminForm.get('email').touched)) {
                            <mat-error>
                              @if (adminForm.get('email').errors?.required) {
                                <span>Email is required</span>
                              }
                              @if (adminForm.get('email').errors?.pattern) {
                                <span>Email should be abc&#64;example.com</span>
                              }
                              <!--<span *ngIf="adminForm.get('email').errors?.duplicateEmail">This email ID is already associated with another user in this organization. Please use a different email ID.</span>-->
                            </mat-error>
                          }
                          @if (adminForm.get('email').errors?.duplicateEmail && (adminForm.get('email').dirty || adminForm.get('email').touched)) {
                            <div class="text-danger" style="font-size: 0.875rem; margin-top: 0.25rem;">
                              This email ID is already associated with another user in this organization. Please use a different email ID.
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label class="form-control-label">Alternate Email</label>
                          <input type="email" formControlName="alternate_email" class="form-control" placeholder="Enter Alternate Email">
                          @if (adminForm.get('alternate_email').invalid && (adminForm.get('alternate_email').dirty || adminForm.get('alternate_email').touched)) {
                            <mat-error>
                              @if (adminForm.get('alternate_email').errors?.pattern) {
                                <span>Email should be abc&#64;example.com</span>
                              }
                            </mat-error>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-group required">
                          <label class="form-control-label">Phone</label>
                          <input type="text" formControlName="phone" class="form-control" placeholder="Enter Phone Number">
                          @if (adminForm.get('phone').invalid && (adminForm.get('phone').dirty || adminForm.get('phone').touched)) {
                            <mat-error>Phone is required</mat-error>
                          }
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label class="form-control-label">Alternate Phone</label>
                          <input type="text" formControlName="alternate_phone" class="form-control" placeholder="Enter Alternate Phone">
                        </div>
                      </div>
                    </div>
                    @if (adminForm.contains('wantPassword')) {
                      <div class="row pinCodeBlock">
                        <div class="col-lg-12">
                          <div class="form-group required">
                            <label class="form-control-label">Do you want to update password:</label><br/>
                              <mat-radio-group
                                class="radio-group"
                                aria-label="Select an option"
                                formControlName="wantPassword"
                                (change)="updatePwdFields()">

                                <mat-radio-button value="true">Yes</mat-radio-button>
                                <mat-radio-button value="false">No</mat-radio-button>

                              </mat-radio-group>
                          </div>
                        </div>
                      </div>
                    }
                    @if (adminForm.contains('setPassword')) {
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="form-group required">
                            <label class="form-control-label">Set Password:</label><br/>
                             <mat-radio-group
                                class="radio-group"
                                aria-label="Select an option"
                                formControlName="setPassword"
                                (change)="updatePassword()">

                                <mat-radio-button value="false">Type Manually</mat-radio-button>
                                <mat-radio-button value="true">Auto Generate</mat-radio-button>

                              </mat-radio-group>
                          </div>
                        </div>
                        @if (adminForm.contains('password')) {
                          <div class="col-lg-6">
                            <div class="form-group required">
                              <label class="form-control-label">Password</label>
                              <div style="display: flex; gap: 0.3rem;">
                                <input [type]="showPassword ? 'text' : 'password'" [readonly]="adminForm.get('setPassword').value === 'true'" formControlName="password" class="form-control" placeholder="Password">
                                <button type="button" class="btn btn-outline-secondary eye-toggle-btn" (click)="togglePasswordVisibility()">
                                  <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                </button>
                              </div>
                              @if (adminForm.get('password').invalid && (adminForm.get('password').dirty || adminForm.get('password').touched)) {
                                <mat-error>
                                  @if (adminForm.get('password').errors?.required) {
                                    <span>Password is required</span>
                                  }
                                  @if (adminForm.get('password').errors?.missingNumber) {
                                    <span>Password must have at least one digit</span>
                                  }
                                  @if (adminForm.get('password').errors?.missingUpperCase) {
                                    <span>Password must have at least one uppercase letter</span>
                                  }
                                  @if (adminForm.get('password').errors?.missingLowerCase) {
                                    <span>Password must have at least one lowercase letter</span>
                                  }
                                  @if (adminForm.get('password').errors?.missingMinLength) {
                                    <span>Password must have at least 8 characters</span>
                                  }
                                </mat-error>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <div class="row pinCodeBlock">
                      <div class="col-lg-6">
                        <div class="form-group required">
                          <label class="form-control-label">Do you have PIN Code:</label><br/>
                          <mat-radio-group
                            class="radio-group"
                            aria-label="Select an option"
                            formControlName="havePinCode"
                            (change)="updatePinCodeValidation()">

                            <mat-radio-button value="true">Yes</mat-radio-button>
                            <mat-radio-button value="false">No</mat-radio-button>

                          </mat-radio-group>
                        </div>
                      </div>
                      @if (adminForm.get('havePinCode').value == 'true') {
                        <div class="col-lg-6">
                          <div class="form-group required">
                            <label class="form-control-label">PIN Code</label>
                            <div style="display: flex; gap: 0.5rem;">
                              <input type="text" formControlName="pinCode" maxlength="6" class="form-control" placeholder="Pin Code" (keyup.enter)="loadGeography()"/>
                              <button mat-raised-button matTooltip="Load geography" class="search-btn" (click)="loadGeography()" type="button">
                                <mat-icon class="matIconURL">search</mat-icon>
                              </button>
                            </div>
                            @if (adminForm.get('pinCode').errors?.required && (adminForm.get('pinCode').dirty || adminForm.get('pinCode').touched)) {
                              <mat-error>Pin Code is required</mat-error>
                            }
                            @if (adminForm.get('pinCode').errors?.minlength && (adminForm.get('pinCode').dirty || adminForm.get('pinCode').touched)) {
                              <mat-error>Pin Code should be 6 digit number</mat-error>
                            }
                          </div>
                        </div>
                      }
                    </div>
                    <div class="pinCodeBlock">
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="form-group required">
                            <label class="form-control-label">State</label>
                            @if (adminForm.get('havePinCode').value == 'true') {
                              <input type="text" class="form-control" readonly formControlName="state" (change)="stateDropdownList($event)" style="padding: 14px;" placeholder="State"/>
                            }
                            @if (adminForm.get('havePinCode').value != 'true') {
                              <select class="form-control" type="text" style="padding: 14px;" formControlName="state" (change)="stateDropdownList($event)" placeholder="State" size="0">
                                <option value="">-Select State-</option>
                                @for (state of allStateNames; track state) {
                                  <option [value]="state">{{state}}</option>
                                }
                              </select>
                            }
                            @if (adminForm.get('state').invalid && (adminForm.get('state').dirty || adminForm.get('state').touched)) {
                              <mat-error>State is required</mat-error>
                            }
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="form-group required">
                            <label class="form-control-label">District</label>
                            @if (adminForm.get('havePinCode').value == 'true') {
                              <input type="text" class="form-control" readonly formControlName="district"  placeholder="District"/>
                            }
                            @if (adminForm.get('havePinCode').value != 'true') {
                              <select class="form-control" type="text" id="ddlDistrictList" style="padding: 14px;" formControlName="district" placeholder="District" size="0">
                                <option value="">-Select District-</option>
                                @for (name of districts; track name) {
                                  <option [value]="name">{{name}}</option>
                                }
                              </select>
                            }
                            @if (adminForm.get('district').invalid && (adminForm.get('district').dirty || adminForm.get('district').touched)) {
                              <mat-error>District is required</mat-error>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 2rem; margin-bottom: 1rem;">
                      <div class="col-lg-12">
                        <div class="d-flex" style="justify-content: center; gap: 1rem;">
                          <button type="submit"  id="modal-btn-confirm" [disabled]="!adminForm.valid" class="submitbtn">{{ pageType === 'Add' ? 'Save' : 'Update' }}</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</div>
}
